export const developmentLog = Object.freeze([

    {title:'v0.0.0',type:'C',desc:'由于财务无意间转错一笔账，突发奇想是否可以自制一个可以自动显示/隐藏收款码的网页，供自己使用，在经过AI咨询后发现可行，于是这个项目的雏形就在AI的笔下诞生了，项目来源于”WPS手机版条件隐藏单元格方法“的问答'},
    {title:'v0.1.0',type:'C',desc:'设计界面UI架构、数据类型、表单结构'},
    {title:'v0.2.0',type:'C',desc:'构建页面原型'},
    {title:'v0.3.0',type:'M',desc:'更改页面为github风格，引入vue、vant ui、element ui，创建深色模式、浅色模式'},
    {title:'v0.4.0',type:'M',desc:'设置数据项删除按钮'},
    {title:'v0.5.0',type:'C',desc:'引入iconfont图标库'},
    {title:'v0.6.0',type:'M',desc:'修复css样式'},
    {title:'v0.7.0',type:'C',desc:'添加数据校验（无感）'},
    {title:'v0.8.0',type:'C',desc:'加入收款码，并使用base64'},
    {title:'v0.9.0',type:'C',desc:'引入html2Canvas网页图片生成库'},
    {title:'v0.9.1',type:'M',desc:'将收款码图片切换至远程加载，并允许跨域'},
    {title:'v0.9.2',type:'M',desc:'将base64格式图片转换为canvas渲染'},
    {title:'v0.9.3',type:'C',desc:'实现图片本地自动缓存、加载',icon:''},
    {title:'v0.9.4',type:'M',desc:'将图片加载方式切换为使用base64静态加载，修复图片显示样式',icon:''},
    {title:'v0.9.5',type:'M',desc:'修复CORS错误',icon:''},
    {title:'v1.0.0',type:'M',desc:'将图片加载方式切换为用户本地上传，并存储到用户浏览器中，解决CORS错误、样式错乱',icon:''},
    {title:'v1.0.1',type:'NONE',desc:'配置Nginx服务器',icon:''},
    {title:'v1.0.2',type:'M',desc:'适配主题色',icon:''},
    {title:'v1.1.0',type:'C',desc:'添加点击反馈效果',icon:''},
    {title:'v1.1.1',type:'M',desc:'解决反馈效果超出边界问题',icon:''},
    {title:'v1.1.2',type:'M',desc:'修复点击反馈效果干涉',icon:''},
    {title:'v1.2.0',type:'C',desc:'引入界面导览功能，选型IntroJs',icon:''},
    {title:'v1.2.1',type:'M',desc:'适配主题色',icon:''},
    {title:'v1.2.2',type:'M',desc:'修复界面导览遮罩层异常',icon:''},
    {title:'v1.2.3',type:'M',desc:'添加界面导览onBeforeChange事件处理',icon:''},
    {title:'v1.2.4',type:'M',desc:'添加界面导览onAfterChange事件处理',icon:''},
    {title:'v1.2.5',type:'M',desc:'实现界面导览步骤平滑滚动元素',icon:''},
    {title:'v1.2.6',type:'M',desc:'修复由于元素隐藏导致Intro的滚动异常',icon:''},
    {title:'v1.2.7',type:'M',desc:'创建界面导览记忆（基于localStorage）',icon:''},
    {title:'v1.2.8',type:'M',desc:'优化Intro界面导览，分离方法为可复用',icon:''},
    {title:'v1.2.9',type:'M',desc:'修复”too much recursion“异常',icon:''},
    {title:'v1.2.10',type:'M',desc:'修复元素显示异常（Intro）',icon:''},
    {title:'v1.2.11',type:'M',desc:'修复元素滚动异常（Intro）',icon:''},
    {title:'v1.2.12',type:'M',desc:'修复localStorage.getItem取值异常',icon:''},
    {title:'v1.2.13',type:'M',desc:'修改点击反馈层级异常',icon:''},
    {title:'v1.2.14',type:'M',desc:'修复图片生成时的元素隐藏异常',icon:''},
    {title:'v1.2.15',type:'M',desc:'给页面添加主站链接、ICP备案链接',icon:''},
    {title:'v1.2.15',type:'M',desc:'将网站logo、ICP图标转换并压缩为base64',icon:''},
    {title:'v1.2.16',type:'M',desc:'适配主题色',icon:''},
    {title:'v1.2.17',type:'C',desc:'添加设备信息标识',icon:''},
    {title:'v1.2.18',type:'M',desc:'引入platform.js,并完善设备信息',icon:''},
    {title:'v1.2.19',type:'M',desc:'优化设备信息可读性',icon:''},
    {title:'v1.2.20',type:'M',desc:'添加浏览器UA标识识别，优化html2canvas图片导出方式',icon:''},
    {title:'v1.3.0',type:'C',desc:'引入pinyin-pro，实现姓名转拼音大写',icon:''},
    {title:'v1.4.0',type:'C',desc:'引入moment.js时间格式化插件',icon:''},
    {title:'v1.5.0',type:'C',desc:'添加页面朴素视图、卡片视图',icon:''},
    {title:'v1.5.1',type:'M',desc:'修改css样式',icon:''},
    {title:'v1.5.2',type:'M',desc:'适配主题色',icon:''},
    {title:'v1.5.3',type:'M',desc:'优化数据结构',icon:''},
    {title:'v1.6.0',type:'C',desc:'添加开发者日志界面',icon:''},
    {title:'v1.6.1',type:'C',desc:'添加联系作者界面',icon:''},
    {title:'v1.6.2',type:'M',desc:'优化css',icon:''},
    {title:'v1.6.3',type:'M',desc:'优化dev信息界面',icon:''},
    {title:'v1.6.4',type:'M',desc:'完善界面向导',icon:''},
    {title:'v1.6.5',type:'C',desc:'添加剪贴板事件，设备信息单击可复制',icon:''},
    {title:'v1.6.6',type:'M',desc:'完善预定义列数据',icon:''},
    {title:'v1.7.0',type:'C',desc:'设备信息页新增“时钟”组件',icon:''},
    {title:'v1.7.1',type:'C',desc:'增加数字时钟样式，引入网页字体“MapleFont”',icon:''},
    {title:'v1.7.2',type:'M',desc:'切换CDN为本站加载',icon:''},
    {title:'v1.7.3',type:'M',desc:'给时钟添加单击复制',icon:''},
    {title:'v1.7.4',type:'M',desc:'优化了一些样式，修复了一些BUG',icon:''},
    {title:'v2.0.0',type:'M,C',desc:'重新构建项目，添加页面',icon:''},
    {title:'v2.0.1',type:'M,C',desc:'优化组件，引入色彩选择',icon:''},
    {title:'v2.0.2',type:'M',desc:'优化组件，引入CherryMarkdown',icon:''},
    {title:'v2.0.3',type:'M',desc:'优化样式',icon:''},
    {title:'v2.0.4',type:'M',desc:'优化样式，修改localStorage键命名，添加存储在localStorage中的数据项',icon:''},
    {title:'v2.0.5',type:'M,C',desc:'优化样式，添加游客报名行程单，接入混元大模型进行非结构化数据识别',icon:''},
    {title:'v2.1.0',type:'M,C',desc:'优化样式，新增页面/组件/功能',icon:''},
    {title:'v2.1.1',type:'M,C',desc:'优化样式，新增页面/组件/功能',icon:''},
])

export function getLastVersion() {
    return developmentLog[developmentLog.length - 1];
}
